import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean, select } from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';

import { BUTTON_TYPES } from '#components/@types/button';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('DropdownButton', () => ({
		template: '<dms-dropdown-button v-bind="$props" @click="click" :items="items" />',
		computed: {
			items() {
				return [{ text: 'název položky' }];
			},
		},
		methods: {
			click: action('clicked'),
		},
		props: {
			text: {
				default: text('Text', 'Název dropdownu'),
			},
			type: {
				default: select('Typ', BUTTON_TYPES, 'primary'),
			},
			size: {
				default: select('Velikost', ['mini', 'small', 'medium', 'default'], 'mini'),
			},
			round: {
				default: boolean('Zda je zaoblený', true),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
	}));
